<template>
    <div class="product__item-sub-header">
        <span class="product__item-sub-title | u-flex-center u-margin-bottom-responsive">
            <img
                src="../assets/feather-icons/corner-right-down.svg"
                class="u-margin-bottom-inline u-margin-right-inline"
            />
            <small> {{ orderLineItem.name }} {{ trans('order.' + productType) }} </small>
        </span>

        <div class="product__item-actions">
            <div class="field field--check u-padding-right-big" v-if="productType == 'ssl'">
                <label class="field__label">
                    <input
                        v-model="domain.generateCsr"
                        class="u-padding-top"
                        @change="onGenerateCsrChange(domain)"
                        type="checkbox"
                        id="csrToggle"
                    />
                        <small class="u-margin-left-inline u-padding-bottom-narrow u-margin-top-flush">{{ trans('order.generate-csr') }}</small>
                </label>
            </div>
            <simple-text-input
                v-if="isForwardingService"
                v-model="form.forwardingUrl"
                :error="form.errors.first('forwarding_url')"
                :placeholder="trans('order.forwarding-url')"
                name="forwarding_url"
                type="url"
                input-class="field__input field__input-forwarding"
                required
                @input="onChangeForwardingUrl"
            />

            <select-component
                v-if="hasServerOptions"
                class="product__item-select product__item-server"
                :currentOption="currentServer"
                :options="serverOptions"
                :placeholder="trans('order.select-server')"
                @change="setServer"
            />

            <div v-if="isVpsService">
                <div class="layout">
                    <div class="layout__item u-4/5-desk">
                        <div class="field u-full-width">
                            <simple-select-input
                                v-if="isVpsService"
                                v-model="form.vpsTemplate"
                                :options="templates"
                                :error="form.errors.first('subscriptions.vps.0.vps_template_slug')"
                                :label="trans('order.vps-fields.template')"
                                name="vpsTemplate"
                                required
                                @change="setVpsTemplate"
                            />
                        </div>

                        <div class="u-text-left">
                            <password-input
                                v-if="isVpsService"
                                v-model="form.vpsPassword"
                                :error="form.errors.first('subscriptions.vps.0.vps_password')"
                                name="vpsPassword"
                                :label="trans('order.vps-fields.password')"
                                input-class="field__input field__input-vpspassword | u-full-width"
                                required
                                @input="setVpsPassword"
                            />
                        </div>

                        <div class="field u-full-width">
                            <div class="field u-full-width">
                                <simple-text-input
                                        v-if="isVpsService"
                                        v-model="form.vpsSubdomain"
                                        :error="form.errors.first('subscriptions.vps.0.subdomain')"
                                        :label="trans('order.vps-fields.subdomain')"
                                        name="vpsSubdomain"
                                        input-class="field__input field__input-vpssubdomain"
                                        @input="setVpsSubdomain"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <period-select
                class="product__item-select product__item-period"
                v-if="productType !== 'addons'"
                :prices="productPrices"
                :currentPeriod="currentPeriod"
                :registrationType="orderLineItem.status"
                @change="setPeriod"
            />
            <price-display :price="productPrice" class="product__item-actions-price | u-text-gray-dark"/>
            <div class="product__item-delete">
                <a
                    class="product__item-icon | u-align-self-center"
                    @click="removeService({ type: productType, name: orderLineItem.name, domain: domain.domain })"
                >
                    <img src="../assets/feather-icons/trash.svg"/>
                </a>
            </div>
        </div>
        <custom-csr-modal v-if="csrModalVisible && productType == 'ssl'" @close="closeCsrModal"
                          :domain="domain"></custom-csr-modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import PeriodSelect from '@/components/Period/PeriodSelect.vue';
import SelectComponent from '@/components/Select/SelectComponent.vue';
import PriceDisplay from '@/components/Price/PriceDisplay.vue';
import serviceMixin from '../mixins/service.js';
import { Way2Form } from 'relapp-way2forms';
import VpsApi from '../../../vps/src/services/api/vps.js';
import customCsrModal from './CustomCsrModal';
import domain from "relapp-register/src/services/api/domain";

export default {
    components: {
        PeriodSelect,
        PriceDisplay,
        SelectComponent,
        customCsrModal
    },
    mixins: [serviceMixin],
    props: {
        productType: {
            type: String,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                forwardingUrl: null,
                vpsTemplate: null,
                validatedCsr: null,
                customCsr: false
            }),
            csrModalVisible: false,
        };
    },
    computed: {
        ...mapGetters({
            formErrors: 'order/formErrors',
            templates: 'vps/templates'
        })
    },
    /**
     * Called when the instance is created.
     */
    created() {
        this.addCsrToDomain();
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.form.populate({
            forwardingUrl: this.orderLineItem.forwarding_url
        });

        if (this.isVpsService) {
            VpsApi.templates();
            this.form.populate({
                vpsTemplate: 'ubuntu_20.04'
            });
            this.setVpsTemplate('ubuntu_20.04');
        }
        /**
         * Receiving submitted and validated Csr.
         */
        this.$root.$on('submitValidatedCsr', (receivedValidatedCsr, domain) => {
            this.addCsrToPayload(receivedValidatedCsr, domain);
        });
        /**
         *  Closing modal properly.
         */
        this.$root.$on('closedModal', () => {
            this.closeCsrModal();
        });
        /**
         *  Adding csr has been canceled reverting the payload.
         */
        this.$root.$on('cancellingModal', (domain) => {
            this.cancelModal(domain);
        });
    },
    methods: {
        ...mapActions({
            updateSslCsr: 'order/updateSslCsr',
            updateSslGenerateCsr: 'order/updateSslGenerateCsr'
        }),
        /**
         * Adding the generateCSR property to the domain.
         */
        addCsrToDomain() {
            for (let x in this.domain) {
                this.domain.generateCsr = true;
                this.updateSslGenerateCsrInPayload(true,this.domain);
            }
        },
        /**
         * Updates the forwarding url entered for hosting.
         *
         * @param {string} enteredForwardingUrl
         */
        onChangeForwardingUrl(enteredForwardingUrl) {
            this.setForwardingUrl(enteredForwardingUrl);
        },
        /**
         * Checking if the user wants to generate the csr or not.
         * @param {object} domain
         */
        onGenerateCsrChange(domain) {
            if (!domain.generateCsr == true) {
                this.openCsrModal();
            }
            this.updateSslGenerateCsrInPayload(domain.generateCsr,domain);
        },
        /**
         * Opens the custom Csr Modal
         */
        openCsrModal() {
            this.csrModalVisible = true;
        },
        /**
         * Close the custom Csr Modal
         */
        closeCsrModal() {
            this.csrModalVisible = false;
        },
        /**
         * Cancel the custom Csr modal reverting the checkbox state to true.
         *
         * @param {object} domain
         */
        cancelModal(domain) {
            this.closeCsrModal();
            domain.generateCsr = true;
            this.updateSslGenerateCsr({
                domain: domain.domain,
                generateCsr: true
            });
        },
        /**
         * Adding validated csr to payload.
         * @param {string} receivedValidatedCsr
         * @param {object} domain
         */
        addCsrToPayload(receivedValidatedCsr, domain) {
            this.validatedCsr = receivedValidatedCsr;
            this.updateSslCsr({
                domain: domain.domain,
                validCsr: this.validatedCsr
            });
        },
        /**
         * Adding generateCsr true or false to payload.
         * @param {boolean} generateCsr
         * @param {object} domain
         */
        updateSslGenerateCsrInPayload(generateCsr, domain) {
            this.updateSslGenerateCsr({
                domain: domain.domain,
                generateCsr: generateCsr
            });

            this.updateSslCsr({
                domain: domain.domain,
                validCsr: ""
            });

        }
    },
    watch: {
        formErrors: {
            /**
             * Watcher for the form errors
             *
             * @param {array} errors
             */
            handler(errors) {
                this.form.errors.record(errors);
            },
            deep: true
        }
    },
};
</script>
